import { render, staticRenderFns } from "./Shutters_comp.vue?vue&type=template&id=5a8ba318&scoped=true&"
import script from "./Shutters_comp.vue?vue&type=script&lang=js&"
export * from "./Shutters_comp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8ba318",
  null
  
)

export default component.exports